import React from 'react';
import { render } from 'react-dom';
import App from './components/App';

console.log(
  `@cimpress/react-components version: ${process.env.VERSION}` +
    (process.env.COMMIT_SHA ? ` (${process.env.COMMIT_SHA})` : ''),
);

const container = document.getElementById('root');
render(<App />, container);
